import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Authenticator from 'ui/containers/Authenticator';
import MainLayout from 'ui/layouts/MainLayout';
import Authentication from 'ui/pages/authentication';



const MainRoutes = () => {
  return (

      <Routes>
        <Route path='/auth' element={ <Authentication />} />
        <Route path='*' element={ <MainLayout />} />
      </Routes>

  )
}

export default MainRoutes;